export const apiFetch = (state = {}, action) => {

    var tmpObj = {};

    switch (action.type) {
        case "initApiFetch": tmpObj = { ...state, estado: "init" };
            return { ...state, ...tmpObj };
        case "fetchingApiFetch": tmpObj = { ...state, estado: "fetching" };
            return { ...state, ...tmpObj };
        case "doneApiFetch": tmpObj = { ...state, estado: "done", ...action.value };
            return { ...state, ...tmpObj };

        case "initFrmTerceroCuentasTmp": tmpObj = { ...state, FrmTerceroCuentasTmp: "init" };
            return { ...state, ...tmpObj };
        case "fetchingFrmTerceroCuentasTmp": tmpObj = { ...state, FrmTerceroCuentasTmp: "fetching" };
            return { ...state, ...tmpObj };
        case "doneFrmTerceroCuentasTmp": tmpObj = { ...state, FrmTerceroCuentasTmp: "done", };
            return { ...state, ...tmpObj };


        case "initRptCtasDetalles": tmpObj = { ...state, RptCtasDetalles: "init" };
            return { ...state, ...tmpObj };
        case "fetchingRptCtasDetalles": tmpObj = { ...state, RptCtasDetalles: "fetching" };
            return { ...state, ...tmpObj };
        case "doneRptCtasDetalles": tmpObj = { ...state, RptCtasDetalles: "done", };
            return { ...state, ...tmpObj };

        case "initRptCtasDetallesMes": tmpObj = { ...state, RptCtasDetallesMes: "init" };
            return { ...state, ...tmpObj };
        case "fetchingRptCtasDetallesMes": tmpObj = { ...state, RptCtasDetallesMes: "fetching" };
            return { ...state, ...tmpObj };
        case "doneRptCtasDetallesMes": tmpObj = { ...state, RptCtasDetallesMes: "done", };
            return { ...state, ...tmpObj };

        case "initRptCtasDetallesDia": tmpObj = { ...state, RptCtasDetallesDia: "init" };
            return { ...state, ...tmpObj };
        case "fetchingRptCtasDetallesDia": tmpObj = { ...state, RptCtasDetallesDia: "fetching" };
            return { ...state, ...tmpObj };
        case "doneRptCtasDetallesDia": tmpObj = { ...state, RptCtasDetallesDia: "done", };
            return { ...state, ...tmpObj };

        case "initFrmLogin": tmpObj = { ...state, FrmLogin: "init" };
            return { ...state, ...tmpObj };
        case "fetchingFrmLogin": tmpObj = { ...state, FrmLogin: "fetching" };
            return { ...state, ...tmpObj };
        case "doneFrmLogin": tmpObj = { ...state, FrmLogin: "done", };
            return { ...state, ...tmpObj };

        case "initFrmConsulta": tmpObj = { ...state, FrmConsulta: "init" };
            return { ...state, ...tmpObj };
        case "fetchingFrmConsulta": tmpObj = { ...state, FrmConsulta: "fetching" };
            return { ...state, ...tmpObj };
        case "doneFrmConsulta": tmpObj = { ...state, FrmConsulta: "done", };
            return { ...state, ...tmpObj };

        case "setProcesos": tmpObj = { ...state, resp: "done", getProcesos: action.value.Procesos };
            return { ...state, ...tmpObj };

        //autoCompletar
        case "setCodProcesoLst":
            tmpObj = { ...state, resp: "done", getCodProceso: action.value.Providencia };
            return { ...state, ...tmpObj };

        case "setMagistradoLst":
            tmpObj = { ...state, resp: "done", getMagistrado: action.value.Persona };
            return { ...state, ...tmpObj };

        case "setDemandanteLst":
            tmpObj = { ...state, resp: "done", getDemandante: action.value.Persona };
            return { ...state, ...tmpObj };

        case "setDemandadoLst":
            tmpObj = { ...state, resp: "done", getDemandado: action.value.Persona };
            return { ...state, ...tmpObj };

        case "setInstanciaLst":
            tmpObj = { ...state, resp: "done", getInstancia: action.value.Instancia };
            return { ...state, ...tmpObj };

        case "setAccionLst":
            tmpObj = { ...state, resp: "done", getAccion: action.value.Tipoaccion };
            return { ...state, ...tmpObj };

        case "setDescriptorLst":
            tmpObj = { ...state, resp: "done", getDescriptor: action.value.Descriptor };
            return { ...state, ...tmpObj };

        case "setRestrictorLst":
            tmpObj = { ...state, resp: "done", getRestrictor: action.value.Restrictor };
            return { ...state, ...tmpObj };

        case "setDecisionLst":
            tmpObj = { ...state, resp: "done", getDecision: action.value.Decision };
            return { ...state, ...tmpObj };

        case "setContadorDetalle":
            tmpObj = { ...state, resp: "done", getContadorDetalle: action.value.detalle };
            return { ...state, ...tmpObj };

        case "setContadorDetalleMes":
            tmpObj = { ...state, resp: "done", getContadorDetalleMes: action.value.meses, getContadorDetalleUltMes: action.value.ultMes };
            return { ...state, ...tmpObj };

        case "setContadorDetalleDia":
            tmpObj = { ...state, resp: "done", getContadorDetalleDia: action.value.dias };
            return { ...state, ...tmpObj };

        case "sendPost": tmpObj = { ...state, postState: "running" };
            return { ...state, ...tmpObj };

        case "initPost": tmpObj = { ...state, postState: "init", postData: "" };
            return { ...state, ...tmpObj };

        case "setPost":
            tmpObj = { ...state, postState: "finished", postData: action.value };
            return { ...state, ...tmpObj };

        default:
            return state;
    }

}


/*
estado:init -> se inicializo el formulario y esta listo para consulta
estado:fetching -> se esta haciendo una consulta se debe mostrar la espera
estado:done -> la consulta finalizo se deben mostrar los datos

*/